import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=4065f263&scoped=true&"
import script from "./ReLogin.vue?vue&type=script&lang=js&"
export * from "./ReLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReLogin.vue?vue&type=style&index=0&id=4065f263&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4065f263",
  null
  
)

export default component.exports